import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { styles } from "./shared";

export default function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    ["NEKRETNINE", "/#nekretnine"],
    ["O NAMA", "/#onama"],
    ["KONTAKT", "/#kontakt"],
  ];

  return (
    <nav style={{ ...styles.nav, background: scrolled ? "rgba(8,8,8,0.97)" : "transparent" }}>
      <div style={styles.navInner}>
        <Link to="/" style={styles.logo}>
          <svg width="26" height="26" viewBox="0 0 100 100" style={{ marginRight: 4 }}>
            <path d="M28,80 L28,46 A22,22 0 0,1 72,46 L72,80" fill="none" stroke="#e8e0d4" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round"/>
            <line x1="18" y1="80" x2="82" y2="80" stroke="#e8e0d4" strokeWidth="7" strokeLinecap="round"/>
            <circle cx="50" cy="24" r="8" fill="#c9a96e"/>
          </svg>
          <span style={styles.logoMain}>NEKRETNINE</span><span style={styles.logoYear}>U ŠPANIJI</span>
        </Link>
        <div style={styles.navLinks} className="navLinks">
          {links.map(([label, to]) => (
            <Link key={label} to={to} style={styles.navLink}>{label}</Link>
          ))}
        </div>
        <button style={styles.hamburger} className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Meni">
          <span style={{ ...styles.bar, transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none" }} />
          <span style={{ ...styles.bar, opacity: menuOpen ? 0 : 1 }} />
          <span style={{ ...styles.bar, transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none" }} />
        </button>
      </div>
      {menuOpen && (
        <div style={styles.mobileMenu}>
          {links.map(([label, to]) => (
            <Link key={label} to={to} style={styles.mobileLink} onClick={() => setMenuOpen(false)}>{label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}
